import { render, staticRenderFns } from "./envGovData.vue?vue&type=template&id=0e75fe97"
import script from "./envGovData.vue?vue&type=script&lang=js"
export * from "./envGovData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e75fe97')) {
      api.createRecord('0e75fe97', component.options)
    } else {
      api.reload('0e75fe97', component.options)
    }
    module.hot.accept("./envGovData.vue?vue&type=template&id=0e75fe97", function () {
      api.rerender('0e75fe97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/air/mst/envGovData.vue"
export default component.exports